import {
  Pagination,
  PaginationContent,
  PaginationEllipsis,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
} from '@/components/ui/pagination';
import { cn } from '@/lib/utils';
import { PaginationResult } from '@/types';

const TablePagination = ({
  className,
  pageProp,
}: {
  className?: string;
  pageProp: Omit<PaginationResult<unknown>, 'data' | 'from' | 'to' | 'total'>;
}) => {
  const paginationItems = pageProp.links
    .slice(1, -1)
    .map(({ active, label, url }, index) => {
      let children = null;

      if (label === '...') {
        children = <PaginationEllipsis />;
      } else {
        children = (
          <PaginationLink isActive={active} href={url}>
            {label}
          </PaginationLink>
        );
      }

      return <PaginationItem key={index}>{children}</PaginationItem>;
    });

  return (
    <Pagination>
      <PaginationContent className={cn('flex-wrap justify-center', className)}>
        <PaginationItem>
          <PaginationPrevious
            href={pageProp.prev_page_url ?? ''}
            disabled={!pageProp.prev_page_url}
          />
        </PaginationItem>

        {paginationItems}

        <PaginationItem>
          <PaginationNext
            href={pageProp.next_page_url ?? ''}
            disabled={!pageProp.next_page_url}
          />
        </PaginationItem>
      </PaginationContent>
    </Pagination>
  );
};

export default TablePagination;
